/* ARTSY+ (kundeklubben) i temaet: tilmelding, pop-up og "slet min konto".
   Sender til /apps/klub/… på butikkens eget domæne. Shopify (app proxy) sender
   videre til klubbens server og underskriver kaldet, så serveren ved, at det kom
   fra butikken - og hvem der er logget ind. Kunde-id kommer ALDRIG herfra.
   Formularerne findes på flere steder og tegnes om af temaet (kurvskuffen), så
   alt lytter på document og ikke på det enkelte element. */
(function () {
  if (window.__klub) return;
  window.__klub = true;

  var D = {};
  try { D = JSON.parse(document.getElementById('klub-data').textContent); } catch (e) { return; }
  var T = D.tekst || {};
  var URL_KLUB = '/apps/klub';
  var NOEGLE_MEDLEM = 'klub_medlem';        // sat når man har meldt sig ind i denne browser
  var NOEGLE_KVIT = 'klub_kvit';            // kvitteringen, så den overlever at kurven tegnes om
  var NOEGLE_LUKKET = 'klub_pop_lukket';    // hvornår pop-uppen sidst blev lukket
  var PAUSE_DAGE = 14;                      // så længe et "nej tak" holder

  function hent(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function gem(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function hentS(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function gemS(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function gyldigMail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim()); }
  function gyldigMobil(v) {
    var r = (v || '').replace(/[\s\-().]/g, '');
    if (r === '' || /^\+\d{0,3}$/.test(r)) return true;      // tomt eller kun landekode = intet nummer
    return /^(\+\d{8,15}|00\d{8,15}|\d{8,12})$/.test(r);
  }
  function felt(form, navn) { return form.querySelector('[data-felt="' + navn + '"]'); }
  function fejl(f, ja) { if (f) f.classList.toggle('klub-fejl', !!ja); }

  function besked(form, html, ok) {
    var p = form.querySelector('.klub-besked');
    if (!p) return;
    p.innerHTML = html;
    p.classList.toggle('klub-besked--ok', !!ok);
    p.hidden = !html;
  }

  /* ---- kvitteringen --------------------------------------------------- */
  function visKvit(boks, k) {
    var form = boks.querySelector('[data-klub-form]');
    var kv = boks.querySelector('[data-klub-kvit]');
    if (!form || !kv) return;
    form.hidden = true;
    kv.hidden = false;
    kv.querySelector('[data-klub-kvit-h]').textContent = k.allerede ? T.allerede : T.velkommen;
    var intro = kv.querySelector('[data-klub-kvit-intro]');
    var kodeboks = kv.querySelector('[data-klub-kvit-kodeboks]');
    var note = kv.querySelector('[data-klub-kvit-note]');
    if (k.allerede) {
      intro.innerHTML = '<a href="' + D.login + '">' + T.log_ind + '</a>';
      kodeboks.hidden = true; note.textContent = '';
    } else if (k.kode) {
      intro.textContent = T.kode_intro;
      kodeboks.hidden = false;
      kv.querySelector('[data-klub-kvit-kode]').textContent = k.kode;
      kv.querySelector('[data-klub-kopier]').textContent = T.kopier;
      note.textContent = (k.lagt ? T.kode_kurv + ' ' : '') + T.kode_mail;
    } else {
      intro.textContent = '';
      kodeboks.hidden = true;
      note.innerHTML = k.test ? '<span class="klub-kvit__test">' + T.test + '</span>' : T.kode_mail;
    }
  }

  function visGemteKvit() {
    var raa = hentS(NOEGLE_KVIT);
    if (!raa) return;
    var k; try { k = JSON.parse(raa); } catch (e) { return; }
    document.querySelectorAll('[data-klub-tilmeld]').forEach(function (b) {
      if (!b.querySelector('[data-klub-kvit]').hidden) return;
      visKvit(b, k);
    });
  }

  /* Koden lægges i kurven med det samme: Shopify husker den i en cookie og
     trækker den fra i kassen. På kurvsiden genindlæses siden, så rabatten ses. */
  function laegIKurv(kode) {
    return fetch('/discount/' + encodeURIComponent(kode), { credentials: 'same-origin', redirect: 'follow' })
      .then(function () { return true; }).catch(function () { return false; });
  }

  /* ---- tilmeld -------------------------------------------------------- */
  document.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('.klub-felt');
    if (!f || !f.classList.contains('klub-fejl')) return;
    var navn = f.getAttribute('data-felt');
    if ((navn === 'mail' && gyldigMail(e.target.value)) || (navn === 'mobil' && gyldigMobil(e.target.value))) fejl(f, false);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-klub-form]');
    if (!form) return;
    e.preventDefault();
    var knap = form.querySelector('.klub-knap');
    if (knap.getAttribute('aria-busy') === 'true') return;   // allerede sendt, vent på svaret

    var mailEl = form.querySelector('[name="mail"]');
    var mobilEl = form.querySelector('[name="mobil"]');
    var mail = mailEl ? mailEl.value.trim() : '';
    var mobil = mobilEl ? mobilEl.value.trim() : '';
    var ok = true;
    if (!gyldigMail(mail)) { fejl(felt(form, 'mail'), true); ok = false; }
    if (mobilEl && !gyldigMobil(mobil)) { fejl(felt(form, 'mobil'), true); ok = false; }
    besked(form, '');
    if (!ok) { var f1 = form.querySelector('.klub-fejl .klub-input'); if (f1) f1.focus(); return; }
    if (/^\+\d{0,3}$/.test(mobil.replace(/\s/g, ''))) mobil = '';

    var tekst = knap.textContent;
    knap.setAttribute('aria-busy', 'true');
    knap.textContent = T.sender;
    var fra = form.getAttribute('data-fra') || '';

    fetch(URL_KLUB + '/tilmeld', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ mail: mail, mobil: mobil, sprog: D.sprog, fra: fra })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { s: r.status, d: d }; }); })
      .then(function (x) {
        knap.removeAttribute('aria-busy');
        knap.textContent = tekst;
        var d = x.d || {};
        if (x.s === 200 && d.medlem) {
          var k = { kode: d.kode || null, test: !!d.test, allerede: !!d.allerede, lagt: false };
          // ARTSY Mails' mærke: så ved butiksmåleren, hvem browseren tilhører, og efterladt kurv kan nå det nye medlem.
          if (typeof d.maerke === 'string' && d.maerke) gem('artsy_maerke', d.maerke);
          var boks = form.closest('[data-klub-tilmeld]');
          var faerdig = function () {
            gemS(NOEGLE_KVIT, JSON.stringify(k));
            visKvit(boks, k);
            // Først NU huskes medlemskabet: blev det gemt før kvitteringen stod der, skjulte boksen sig selv uden besked (21/10-2026).
            gem(NOEGLE_MEDLEM, '1');
            visGemteKvit();
            document.dispatchEvent(new CustomEvent('klub:medlem', { detail: k }));
            if (k.lagt && D.side === 'cart') setTimeout(function () { location.reload(); }, 1200);
          };
          if (k.kode) laegIKurv(k.kode).then(function (lagt) { k.lagt = lagt; faerdig(); });
          else faerdig();
          return;
        }
        if (d.felt === 'mail') { fejl(felt(form, 'mail'), true); return; }
        if (d.felt === 'mobil') { fejl(felt(form, 'mobil'), true); return; }
        besked(form, x.s === 429 ? T.for_mange : T.fejl_server);
      })
      .catch(function () {
        knap.removeAttribute('aria-busy');
        knap.textContent = tekst;
        besked(form, T.fejl_server);
      });
  });

  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-klub-kopier]');
    if (!k) return;
    var kode = k.parentNode.querySelector('[data-klub-kvit-kode]').textContent;
    var faerdig = function () { k.textContent = T.kopieret; setTimeout(function () { k.textContent = T.kopier; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(kode).then(faerdig, faerdig); else faerdig();
  });

  /* ---- pop-uppen ------------------------------------------------------ */
  var pop = document.getElementById('klub-pop');
  var fane = document.getElementById('klub-fane');
  var tvang = /[?&]klub-popup=vis\b/.test(location.search);    // til at se den før den er tændt

  function lukketFornylig() {
    var t = parseInt(hent(NOEGLE_LUKKET) || '0', 10);
    return t && Date.now() - t < PAUSE_DAGE * 864e5;
  }
  function maaVises() {
    if (!pop) return false;
    if (tvang) return true;
    if (D.medlem || D.b2b || hent(NOEGLE_MEDLEM)) return false;
    if (/[?&]af=/.test(location.search)) return false;           // kom fra en af vores egne mails
    return true;
  }
  var aaben = false, sidstFokus = null;
  function vis() {
    // Lukket inden for de sidste 14 dage: kun fanen/linket (tvang) må åbne den igen.
    // Før blev udløserne ved med at lytte efter et luk, så den kom igen og igen (Martin 20/10-2026).
    if (aaben || !maaVises() || (!tvang && lukketFornylig())) return;
    // Landepopuppen (snippets/artsy-landepopup.liquid) er i spil på denne side: vent til næste side (20/10-2026).
    if (!tvang && document.documentElement.hasAttribute('data-af-land')) return;
    aaben = true;
    sidstFokus = document.activeElement;
    pop.hidden = false;
    if (fane) fane.hidden = true;
    document.documentElement.style.overflow = 'hidden';
    var i = pop.querySelector('.klub-input, .klub-knap');
    if (i && window.matchMedia('(min-width: 601px)').matches) setTimeout(function () { i.focus(); }, 50);
  }
  function luk() {
    if (!aaben) return;
    aaben = false;
    pop.hidden = true;
    document.documentElement.style.overflow = '';
    var medlem = !!hent(NOEGLE_MEDLEM);
    if (!medlem) { gem(NOEGLE_LUKKET, String(Date.now())); if (fane) fane.hidden = false; }
    if (sidstFokus && sidstFokus.focus) sidstFokus.focus();
  }

  if (pop) {
    pop.addEventListener('click', function (e) { if (e.target.closest('[data-klub-luk]')) luk(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && aaben) luk(); });
    if (fane) fane.addEventListener('click', function () { tvang = true; vis(); });
    document.addEventListener('klub:medlem', function () { if (fane) fane.hidden = true; });

    if (maaVises()) {
      if (tvang) { vis(); }
      else if (lukketFornylig()) { if (fane) fane.hidden = false; }
      else {
        // Udløses når kunden er på vej væk (musen mod adresselinjen), eller efter 20 sekunder.
        // På mobil også ved et hurtigt ryk opad (typisk på vej tilbage til menuen).
        // Højst én automatisk visning pr. sidevisning.
        var autoVist = false;
        function autoVis() { if (autoVist) return; autoVist = true; clearTimeout(timer); vis(); }
        var timer = setTimeout(autoVis, 20000);
        document.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY <= 0) autoVis();
        });
        var sidsteY = window.scrollY, sidsteT = Date.now();
        window.addEventListener('scroll', function () {
          var y = window.scrollY, t = Date.now();
          if (y > 600 && sidsteY - y > 250 && t - sidsteT < 400) autoVis();
          sidsteY = y; sidsteT = t;
        }, { passive: true });
      }
    }
  }

  /* ---- slet min konto (Bliv medlem-siden, for medlemmer) --------------- */
  document.addEventListener('click', function (e) {
    var slet = e.target.closest && e.target.closest('[data-klub-slet]');
    if (!slet) return;
    var boks = slet.querySelector('[data-klub-slet-boks]');
    var start = slet.querySelector('[data-klub-slet-start]');
    var bsk = slet.querySelector('[data-klub-slet-besked]');
    if (e.target.closest('[data-klub-slet-start]')) { boks.hidden = false; start.hidden = true; return; }
    if (e.target.closest('[data-klub-slet-nej]')) { boks.hidden = true; start.hidden = false; return; }
    var ja = e.target.closest('[data-klub-slet-ja]');
    if (!ja || ja.getAttribute('aria-busy') === 'true') return;
    ja.setAttribute('aria-busy', 'true');
    fetch(URL_KLUB + '/slet-konto', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: '{}' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { s: r.status, d: d }; }); })
      .then(function (x) {
        ja.removeAttribute('aria-busy');
        bsk.hidden = false;
        if (x.s === 200 && x.d.ok) {
          boks.hidden = true;
          bsk.className = 'klub-besked klub-besked--ok';
          bsk.textContent = x.d.test ? T.test : T.slet_ok;
          if (!x.d.test) setTimeout(function () { location.href = '/account/logout'; }, 3500);
        } else {
          bsk.textContent = T.fejl_server;
        }
      })
      .catch(function () { ja.removeAttribute('aria-busy'); bsk.hidden = false; bsk.textContent = T.fejl_server; });
  });

  /* Temaet tegner kurvskuffen om, når kurven ændres. Har kunden lige meldt sig ind,
     skal den nye skuffe vise kvitteringen og ikke formularen igen. */
  /* Har man meldt sig ind i denne browser, men er ikke logget ind, kan temaet ikke
     se det. Så skjules tilbuddet og formularen i kurven og på varesiden, i stedet
     for at bede om mailen igen (Martin 19/10-2026). Kvitteringen med koden vises
     stadig, så længe fanen er åben. */
  function skjulForMedlem() {
    if (!hent(NOEGLE_MEDLEM)) return;
    document.querySelectorAll('.klub-kurv:not(.klub-kurv--medlem), .klub-vare:not(.klub-vare--medlem)').forEach(function (b) {
      var kv = b.querySelector('[data-klub-kvit]');
      if (kv && !kv.hidden) return;
      b.hidden = true;
      b.style.display = 'none';
    });
  }

  visGemteKvit();
  skjulForMedlem();
  // Kurvskuffen er ofte tegnet, før man melder sig ind. Opdatér den med det samme.
  document.addEventListener('klub:medlem', function () { visGemteKvit(); skjulForMedlem(); });
  var venter = false;
  new MutationObserver(function () {
    if (venter || !(hentS(NOEGLE_KVIT) || hent(NOEGLE_MEDLEM))) return;
    venter = true;
    requestAnimationFrame(function () { venter = false; visGemteKvit(); skjulForMedlem(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
